import React, { Component } from 'react';
import logo from '../logo.svg';
import '../App.css';
import {withRouter} from 'react-router-dom';
var $ = require('jquery');
class Header extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <h1>Fisher & Ho</h1>
          <div className="container">
            <div className="row">
                <span>Certified Public Accountants</span>
                <ul>
                  <li><a href="/">Home</a></li>
                  <li><a href="/about">About</a></li>
                  <li><a href="/services">Services</a></li>
                </ul>
            </div>
          </div>
        </header>

      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js